import { format, isAfter, parseISO } from "date-fns";
import { Membership, MembershipCriteria } from "../types/profile";
import { UserMembership } from "../types/checkout";
import { get } from "./fetch.core";

export function getMembershipDiscountLabel(membership: UserMembership | Membership | null) {
  if (!membership?.name) return "";

  const discountPer = membership.discount?.per;
  if (!discountPer) return String(membership.name);

  const zheValue = (100 - discountPer) / 10;
  const zheLabel = zheValue % 1 === 0 ? `${zheValue}折` : `${zheValue.toFixed(1)}折`;

  return `${membership.name} ${zheLabel}`;
}

export function isActiveMembership(membership: Membership) {
  const expirationDate = getExpirationDate(membership);
  if (!expirationDate) return false;

  return isAfter(expirationDate, new Date());
}

export function getEndDate(membership: Membership) {
  const expirationDate = getExpirationDate(membership);
  if (!expirationDate) return "N/A";

  return format(expirationDate, "yyyy-MM-dd");
}

function getExpirationDate(membership: Membership) {
  if (!membership.expiration && !membership.manualExpiration) return null;

  return parseISO((membership.manualExpiration ?? membership.expiration)!);
}

async function getMembershipCriteria() {
  const res = await get<MembershipCriteria>("/public/membership/getCriteria");
  return res.data;
}

const membershipCore = {
  getMembershipCriteria,
};

export default membershipCore;
